/** Leerer Ergebniszustand: Es liegen keine substanziellen Antworten vor
 * (alle Fragen „Keine Angabe"), daher gibt es keinen Score und keine
 * Reifegrad-Einstufung — statt fälschlich „Customer-Blind" mit 0,0 zu zeigen. */
export function NoEvaluationNotice({
  onRestart,
  message = 'Alle Fragen wurden mit „Keine Angabe" beantwortet. Für eine Einordnung des Reifegrads wird mindestens eine bewertete Frage benötigt.'
}: {
  onRestart: () => void;
  message?: string;
}) {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-5 text-center">
      <h1
        className="text-display-sm tracking-tight text-zeb-tertiary"
        style={{ fontFamily: 'var(--font-heading)', fontWeight: 700, letterSpacing: '-0.02em' }}>
        Keine Auswertung möglich
      </h1>
      <p className="max-w-md text-body-lg text-zeb-gray-600">{message}</p>
      <button onClick={onRestart} className="text-sm text-zeb-primary hover:underline">
        Check erneut starten
      </button>
    </div>
  );
}
